import type { SyncStateItem } from 'src/modules/syncing';
import type { Action } from 'src/types';

export const SYNCING_UPDATED = 'SYNCING_UPDATED';

export type State = Record<string, SyncStateItem[]>;

export type SyncingAction = Action<typeof SYNCING_UPDATED> & {
  payload: SyncStateItem;
};

const sync = (item: SyncStateItem): SyncStateItem => ({
  ...item,
  state: 'SYNCED',
});

const reduceParent = (state: SyncStateItem[] = [], action: SyncingAction) => {
  const { payload } = action;

  const filteredState = state
    .map((item) => (payload.singleton ? sync(item) : item))
    .filter((item) => item.id !== payload.id);

  return [...filteredState, payload];
};

export const syncingReducer = (
  state: State = {},
  action: SyncingAction,
): State => {
  switch (action.type) {
    case SYNCING_UPDATED:
      const { parent = '' } = action.payload || {};
      return {
        ...state,
        [parent]: reduceParent(state[parent], action),
      };
    default:
      return state;
  }
};
